import { render, staticRenderFns } from "./Permisos.vue?vue&type=template&id=71279c0d&scoped=true&"
import script from "./Permisos.vue?vue&type=script&lang=js&"
export * from "./Permisos.vue?vue&type=script&lang=js&"
import style0 from "./Permisos.vue?vue&type=style&index=0&id=71279c0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71279c0d",
  null
  
)

export default component.exports